import { useContext } from 'react';
import ThemeContext from './ThemeContext.js';

export default function useThemeContext() {
    const value = useContext(ThemeContext);
    return value;
}